import { createElement, Fragment, Component } from 'react';
import { IdProvider } from '../uniqueId.js';
import { node, bool, object } from 'prop-types';
import '../types/props.js';
import { createGlobalStyle, css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import space from '../styled/space.js';
import '../styled/index.js';
import { d as _taggedTemplateLiteralLoose, b as _objectWithoutPropertiesLoose, e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import defaultTheme from '../default/index.js';
import '../default/global.js';
import '../default/layout.js';
import '../default/fontSizes.js';
import '../default/fontWeights.js';
import '../default/Container.js';
import '../default/FieldSet.js';
import '@fortawesome/free-solid-svg-icons/faInfoCircle';
import '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import '@fortawesome/free-solid-svg-icons/faCheckCircle';
import '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import '@fortawesome/free-solid-svg-icons/faTimes';
import '@fortawesome/free-solid-svg-icons/faSearch';
import '../default/Icon.js';
import '../default/LayoutSet.js';
import '../default/Page.js';
import '../default/Pane.js';
import '../default/Table.js';
import 'reakit';
import ThemeProvider from 'reakit/Provider';
import _camelCase from 'lodash/camelCase';
import 'reakit/Portal';
import '../Portal/styled.js';
import '../Portal/index.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import '../Heading/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Toast/styled.js';
import 'lodash/uniqueId';
import '../Toast/ToastContainer.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import '../Toast/ToastClose.js';
import '../Toast/ToastIcon.js';
import '../Toast/ToastTitle.js';
import { a as ToastManager } from '../Toast/ToastManager-796d5d7a.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  html, body {\n    box-sizing: border-box;\n    font-family: ", ";\n    font-size: ", "px;\n    font-weight: ", ";\n    line-height: 1.5;\n    margin: 0;\n    padding: 0;\n    overflow-x: hidden;\n    -webkit-font-smoothing: antialiased;\n    text-rendering: optimizeLegibility;\n    color: ", ";\n    fill: ", ";\n  }\n\n  html.wf-active,\n  html.wf-active > body {\n    font-family: ", ";\n  }\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n\n  *:focus {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Global = createGlobalStyle(_templateObject(), function (props) {
  return theme('fannypack.global.fallbackFontFamily')(props) || theme('fannypack.global.fontFamily')(props);
}, theme('fannypack.global.fontSize'), theme('fannypack.fontWeights.normal'), palette('text'), palette('text'), theme('fannypack.global.fontFamily'), palette('primary'), theme('fannypack.global.base'));

var buildColorFromPalette = function buildColorFromPalette(property, _ref) {
  var theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["theme"]);

  // @ts-ignore
  var color = theme.palette[props[_camelCase(property)]];

  if (typeof color === 'function') {
    color = color(props);
  }

  if (!color) return;
  return property + ": " + color + " !important;";
};

var buildSpacingFromTheme = function buildSpacingFromTheme(property, props) {
  // @ts-ignore
  var spacing = space(props[_camelCase(property)])(props);
  if (!spacing) return;
  return property + ": " + spacing + "rem !important;";
};

var buildFontSizeFromTheme = function buildFontSizeFromTheme(property, _ref2) {
  var theme = _ref2.theme,
      props = _objectWithoutPropertiesLoose(_ref2, ["theme"]);

  // @ts-ignore
  var size = theme.fannypack.fontSizes[props[_camelCase(property)]];

  if (!size) return;
  return property + ": " + size + "rem !important;";
};

var buildFontWeightFromTheme = function buildFontWeightFromTheme(property, _ref3) {
  var theme = _ref3.theme,
      props = _objectWithoutPropertiesLoose(_ref3, ["theme"]);

  // @ts-ignore
  var weight = theme.fannypack.fontWeights[props[_camelCase(property)]];

  if (!weight) return;
  return property + ": " + weight + " !important;";
};

var buildVisibleAttributesFromProps = function buildVisibleAttributesFromProps(props) {
  var breakpoint = props.hiddenBreakpoint || props.showBreakpoint;
  if (!breakpoint) return;
  var key;

  if (props.hiddenBreakpoint && breakpoint.includes('max')) {
    key = 'max-width';
  } else if (props.hiddenBreakpoint && breakpoint.includes('min')) {
    key = 'min-width';
  } else if (props.showBreakpoint && breakpoint.includes('max')) {
    key = 'min-width';
  } else if (props.showBreakpoint && breakpoint.includes('min')) {
    key = 'max-width';
  }

  var strippedBreakpoint = breakpoint;
  strippedBreakpoint = strippedBreakpoint.replace('max-', '');
  strippedBreakpoint = strippedBreakpoint.replace('min-', '');
  var minBreakpointValues = {
    mobile: 0,
    tablet: _get(props, 'theme.fannypack.layout.mobileBreakpoint'),
    desktop: _get(props, 'theme.fannypack.layout.tabletBreakpoint'),
    widescreen: _get(props, 'theme.fannypack.layout.desktopBreakpoint'),
    fullHD: _get(props, 'theme.fannypack.layout.widescreenBreakpoint')
  };

  var breakpointValue = _get(props, "theme.fannypack.layout['" + strippedBreakpoint + "Breakpoint']");

  if (props.hiddenBreakpoint && breakpoint.includes('min')) {
    breakpointValue = minBreakpointValues[strippedBreakpoint] + 1;
  }

  if (props.showBreakpoint && breakpoint.includes('min')) {
    breakpointValue = minBreakpointValues[strippedBreakpoint];
  }

  if (props.showBreakpoint && breakpoint.includes('max')) {
    breakpointValue = breakpointValue + 1;
  }

  if (!breakpoint.includes('min-') && !breakpoint.includes('max-')) {
    if (props.showBreakpoint) {
      return css(["@media screen and (max-width:", "px){display:none;}@media screen and (min-width:", "px){display:none;}"], minBreakpointValues[breakpoint], breakpointValue + 1);
    }

    return css(["@media screen and (min-width:", "px) and (max-width:", "px){display:none;}"], minBreakpointValues[breakpoint] + 1, breakpointValue);
  }

  return css(["@media screen and (", ":", "px){display:none;}"], key, breakpointValue);
};

var reakitTheme = {
  Box: css(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], function (props) {
    return buildColorFromPalette('color', props);
  }, function (props) {
    return buildColorFromPalette('background-color', props);
  }, function (props) {
    return buildColorFromPalette('border-block-end-color', props);
  }, function (props) {
    return buildColorFromPalette('border-block-start-color', props);
  }, function (props) {
    return buildColorFromPalette('border-bottom-color', props);
  }, function (props) {
    return buildColorFromPalette('border-color', props);
  }, function (props) {
    return buildColorFromPalette('border-inline-end-color', props);
  }, function (props) {
    return buildColorFromPalette('border-inline-start-color', props);
  }, function (props) {
    return buildColorFromPalette('border-left-color', props);
  }, function (props) {
    return buildColorFromPalette('border-right-color', props);
  }, function (props) {
    return buildColorFromPalette('border-top-color', props);
  }, function (props) {
    return buildColorFromPalette('border-bottom-color', props);
  }, function (props) {
    return buildColorFromPalette('caret-color', props);
  }, function (props) {
    return buildColorFromPalette('column-rule-color', props);
  }, function (props) {
    return buildColorFromPalette('outline-color', props);
  }, function (props) {
    return buildColorFromPalette('text-decoration-color', props);
  }, function (props) {
    return buildColorFromPalette('text-emphasis-color', props);
  }, function (props) {
    return buildSpacingFromTheme('margin', props);
  }, function (props) {
    return buildSpacingFromTheme('margin-left', props);
  }, function (props) {
    return buildSpacingFromTheme('margin-right', props);
  }, function (props) {
    return buildSpacingFromTheme('margin-top', props);
  }, function (props) {
    return buildSpacingFromTheme('margin-bottom', props);
  }, function (props) {
    return buildSpacingFromTheme('padding', props);
  }, function (props) {
    return buildSpacingFromTheme('padding-left', props);
  }, function (props) {
    return buildSpacingFromTheme('padding-right', props);
  }, function (props) {
    return buildSpacingFromTheme('padding-top', props);
  }, function (props) {
    return buildSpacingFromTheme('padding-bottom', props);
  }, function (props) {
    return buildFontSizeFromTheme('font-size', props);
  }, function (props) {
    return buildFontWeightFromTheme('font-weight', props);
  }, function (props) {
    return buildVisibleAttributesFromProps(props);
  })
};

var loadTheme = function loadTheme(_ref) {
  var _theme = _ref.theme,
      isStandalone = _ref.isStandalone;
  var theme = defaultTheme(_theme);

  if (isStandalone && _theme) {
    theme = _theme;
  }

  if (typeof window !== 'undefined') {
    var webFontLoaderConfig = theme.webFontLoader;

    if (webFontLoaderConfig) {
      // @ts-ignore
      import('webfontloader').then(function (webFontLoader) {
        return webFontLoader.load(webFontLoaderConfig);
      });
    }
  }

  var derivedTheme = _objectSpread({
    fannypack: theme
  }, reakitTheme, theme && theme.reakit ? theme.reakit : {}, {
    palette: theme && theme.palette ? theme.palette : {}
  });

  return derivedTheme;
};

var Provider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Provider, _React$Component);

  function Provider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      theme: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

      var theme = _this.state.theme;
      return createElement(ThemeProvider, _extends({}, props, {
        theme: theme
      }), createElement(IdProvider, null, createElement(Fragment, null, process.env.NODE_ENV !== 'test' && createElement(Global, null), process.env.NODE_ENV !== 'test' && !_get(theme, 'fannypack.Toast.disabled') && createElement(ToastManager, null), children)));
    });

    return _this;
  }

  Provider.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.theme !== state.theme) {
      return {
        theme: loadTheme({
          theme: props.theme,
          isStandalone: props.isStandalone
        })
      };
    }

    return {};
  };

  return Provider;
}(Component);

_defineProperty(Provider, "propTypes", {
  children: node.isRequired,
  isStandalone: bool,
  theme: object
});

_defineProperty(Provider, "defaultProps", {
  isStandalone: false,
  theme: {}
});

export default Provider;
export { Provider as ThemeProvider };
